export default __webpack_public_path__ + "static/media/gallery_01.3e01132c.jpg";